import React from 'react';
import { Outlet } from 'react-router-dom';
import MainHeader from './MainHeader';
import MainFooter from './MainFooter';
import MainPart from './MainPart';
import { useSelector, useDispatch } from 'react-redux';

function MainLayout() {
    const { generalSetting } = useSelector((state) => state?.GeneralSetting);
    return (
        <>
            <MainHeader title={generalSetting?.company_name} faviconIcon={generalSetting?.fav_icon} />
            <MainPart>
                <Outlet />
            </MainPart>
            <MainFooter copyright={generalSetting?.site_copyright} />
        </>
    );
}

export default MainLayout;
